module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', [_vm._v("To those whose support became the bedrock of my journey, I extend my deepest gratitude. In moments where perseverance and strength faltered, you stood as pillars of encouragement. Your belief in me fueled the flame of determination, turning challenges into stepping stones and dreams into reality. To my steadfast companions on this literary odyssey, your presence has been the most cherished gift. This book stands as a testament to our collective resilience, shared triumphs, and the boundless power of a supportive community. Thank you for being the wind beneath my wings; this achievement is as much yours as it is mine.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0